export const SIN_VALOR = '—';

export const formatearNumero = (valor) => {
  if (valor === null || valor === undefined || valor === '') return SIN_VALOR;
  const numero = Number(valor);
  if (!Number.isFinite(numero)) return SIN_VALOR;
  return numero.toLocaleString('es-ES', { maximumFractionDigits: 2 });
};

export const formatearPuntos = (numerador, denominador) => {
  const sinNumerador = numerador === null || numerador === undefined;
  const sinDenominador = denominador === null || denominador === undefined;
  if (sinNumerador && sinDenominador) return SIN_VALOR;
  return `${formatearNumero(numerador)} / ${formatearNumero(denominador)}`;
};

const unir = (...partes) =>
  partes
    .map((p) => (typeof p === 'string' ? p.trim() : ''))
    .filter(Boolean)
    .join(' ');

export const nombreAlumno = (fila) => unir(fila?.nombre, fila?.apellido);

export const nombreEvaluador = (fila) =>
  unir(fila?.evaluador) || unir(fila?.nombre_evaluador, fila?.apellido_evaluador);

export const tieneComentario = (fila) =>
  typeof fila?.comentarios === 'string' && fila.comentarios.trim() !== '';
